import { Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import CommonPageWrapper from '../../../common/components/CommonPageWrapper'
import Loader from '../../../common/loader/Loader'
import { Query } from '../../../react-apollo/Components'
import { i18n } from '../../index'
import GoBackButton from '../GoBackButton'
import { fetchExpressCheckoutEditPeriodPage } from '../expressCheckoutQueries'
import { OpeningHoursPeriod, RestaurantMenu } from '../types'
import { OpeningHoursPeriodForm } from './OpeningHoursPeriodForm'

export default function EditCategoryPeriodPage() {
  const { stationId, categoryId, periodId } = useParams<{ stationId: string; categoryId: string; periodId: string }>()
  const history = useHistory()
  return (
    <CommonPageWrapper title={i18n.t('restaurantMenu.categoryPeriods.editCategoryPeriod')}>
      <GoBackButton stationId={stationId} to={`/pikakassa/${stationId}/aukioloajat/${categoryId}`} />
      <Query<
        {
          expressCheckoutMenu?: RestaurantMenu
          expressCheckoutCategoryPeriod?: OpeningHoursPeriod
          expressCheckoutCategoryPeriods?: OpeningHoursPeriod[]
        },
        { stationId: string; periodId: string }
      >
        query={fetchExpressCheckoutEditPeriodPage}
        variables={{ stationId: decodeURIComponent(stationId), periodId: decodeURIComponent(periodId) }}
        fetchPolicy='network-only'
      >
        {({ data, loading }) => {
          const categories = data?.expressCheckoutMenu?.categories ?? []
          const category = categories.find((c) => c.id === categoryId)
          if (!category) {
            return <Typography variant='h5'>{i18n.t('restaurantMenu.errorMessages.dataNotFound')}</Typography>
          }
          const existingPeriods =
            data?.expressCheckoutCategoryPeriods.filter(
              (p) => p.categoryId === categoryId && p.periodId !== periodId,
            ) || []
          return (
            <Loader loading={loading}>
              <OpeningHoursPeriodForm
                defaultOpeningHours={data?.expressCheckoutCategoryPeriod?.openingHours || {}}
                periodId={data?.expressCheckoutCategoryPeriod?.periodId}
                stationId={stationId}
                category={category}
                defaultPeriodName={data?.expressCheckoutCategoryPeriod?.periodName}
                defaultStartDate={
                  data?.expressCheckoutCategoryPeriod?.startDate
                    ? moment(data.expressCheckoutCategoryPeriod.startDate)
                    : undefined
                }
                defaultEndDate={
                  data?.expressCheckoutCategoryPeriod?.endDate
                    ? moment(data.expressCheckoutCategoryPeriod.endDate)
                    : undefined
                }
                onCompleted={() => history.push(`/pikakassa/${stationId}/aukioloajat/${categoryId}`)}
                existingPeriods={existingPeriods}
              />
            </Loader>
          )
        }}
      </Query>
    </CommonPageWrapper>
  )
}
